<template>
  <div class="centered">
    <progress-bar
      :progress-key="archiveKey"
      :app-id="appId"
      :online-status="status"
      :progress-director="DIRECTOR.deploying"
      :last-modified="lastModifiedTime"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "@vue/composition-api"
import { ProgressCacheKey } from "../ProgressBar.vue"
import { DIRECTOR } from "../../lib/progress-step-director"
import ComponentLogicMixin from "./component-logic.mixin"

export default defineComponent({
  name: "DeployingLogic",
  mixins: [ComponentLogicMixin],
  setup() {
    const archiveKey = ProgressCacheKey.DEPLOYING_CACHE_KEY

    return {
      DIRECTOR,
      archiveKey
    }
  }
})
</script>
